import { type HttpClient } from '../useHttpClient';

export const postUser = (httpClient: HttpClient) => async (data: any) => {
  return await httpClient.api('/admin/aspnetusers', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};
